import { connect } from 'react-redux';
import {getCustomers, getFranchise, getLeads, addLeads, getGeocodeAddress, resetGeocodeAddress,getViewByWorkOrder,getFieldOfficeStaff} from '../../../../Action';
import ViewByWorkOrder from '../Component/ViewByWorkOrder';

const mapStateToProps = (state) => {
  const {
    loading,
    franchise: franchiseData,
    error: settingError} = state.Settings;

  const {
    customerList,GetStaffFieldById,
    error: residentialError
  } = state.CustomerList;

  const {Lead, GoogleApi,FieldStaff,GetViewByWorkOrder} = state;

  return {
    customerList,
    loading,
    franchiseData,
    settingError,
    residentialError,
    Lead,
    GoogleApi,
    GetStaffFieldById,
    FieldStaff,
    GetViewByWorkOrder
  }
}

const actionCreators = {
  getCustomers,
  getLeads,
  addLeads,
  getFranchise,
  getGeocodeAddress,
  resetGeocodeAddress,
  getViewByWorkOrder,
  getFieldOfficeStaff,
}
export default (connect(mapStateToProps, actionCreators)(ViewByWorkOrder));